import React, { useMemo, useState } from 'react';
import { useWindowSize } from 'usehooks-ts';

import CustomToaster from './CustomToaster';
import EmployeeCard from './EmployeeCard';
import MessageModal from './MessageModal';

interface TeamMember {
  bio: string;
  facebookUrl?: string;
  linkedinUrl?: string;
  name: string;
  recentArticle?: string;
  team: string;
  title: string;
  twitter?: string;
  userId: string;
}

interface TeamProps {
  canSendMessage: boolean;
  members: TeamMember[];
}

interface ExpansionsProps {
  canSendMessage: boolean;
  setMessageUser: (user: { id: string; name: string }) => void;
  team: TeamMember[];
}

function Expansions({ team, setMessageUser, canSendMessage }: ExpansionsProps) {
  return (
    <>
      {team.map((member, idx) => (
        <EmployeeCard
          key={idx}
          name={member.name}
          title={member.title}
          bio={member.bio}
          facebookUrl={member.facebookUrl}
          linkedinUrl={member.linkedinUrl}
          twitter={member.twitter}
          recentArticle={member.team === 'editorial' ? member.recentArticle : null}
          canSendMessage={canSendMessage}
          onMessage={() => setMessageUser({ id: member.userId, name: member.name })}
        />
      ))}
    </>
  );
}

export default function Team({ members, canSendMessage }: TeamProps) {
  const [messageUser, setMessageUser] = useState(null);
  const { width } = useWindowSize();

  const twoColumns: TeamMember[][] = useMemo(() => {
    const columns = [[], []];
    members.forEach((member, idx) => {
      columns[idx % 2].push(member);
    });
    return columns;
  }, [members]);

  return (
    <>
      <div className="row">
        {width > 992 ? (
          <div>
            <div className="col-md-6">
              <Expansions
                team={twoColumns[0]}
                setMessageUser={setMessageUser}
                canSendMessage={canSendMessage}
              />
            </div>
            <div className="col-md-6">
              <Expansions
                team={twoColumns[1]}
                setMessageUser={setMessageUser}
                canSendMessage={canSendMessage}
              />
            </div>
          </div>
        ) : (
          <div className="col-md-12">
            <Expansions
              team={members}
              setMessageUser={setMessageUser}
              canSendMessage={canSendMessage}
            />
          </div>
        )}
      </div>
      {canSendMessage && <MessageModal user={messageUser} onClose={() => setMessageUser(null)} />}
      <CustomToaster />
    </>
  );
}
